import classes from "classnames";
import styles from "./index.module.scss";

export interface DifficultyStatsProps {
  className?: string;
  color?: string;
  label: string;
  finished: number;
  total: number;
}
const DifficultyStats = ({
  className,
  label,
  finished,
  total,
  color,
}: DifficultyStatsProps) => {
  return (
    <div className={classes(styles.difficultyStat, className)}>
      <div className={styles.label} style={{ color }}>
        {label}
      </div>
      <div className={styles.finished}>{finished}</div>
      <div className={styles.divider} />
      <div className={styles.total}>{total}</div>
    </div>
  );
};

export default DifficultyStats;
